import { render } from "./SeccompProfile.vue?vue&type=template&id=ed973a16"
import script from "./SeccompProfile.vue?vue&type=script&lang=js"
export * from "./SeccompProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__